import { FilterFn } from "@tanstack/react-table";
import { Creator, StatusValue } from "@/types/types";
import { CreatorAvatar } from "../types";

/** Username column filter: case-insensitive "contains" over username OR email. */
export const multiColumnFilterFn: FilterFn<Creator> = (
  row,
  _columnId,
  filterValue
) => {
  const searchTerm = String(filterValue ?? "").trim().toLowerCase();
  if (!searchTerm) return true;
  const username = String(row.original.username ?? "").toLowerCase();
  const email = String(row.original.email ?? "").toLowerCase();
  return username.includes(searchTerm) || email.includes(searchTerm);
};
multiColumnFilterFn.autoRemove = (value) => !String(value ?? "").trim();

export const statusFilterFn: FilterFn<Creator> = (
  row,
  columnId,
  filterValue: string[]
) => {
  if (!filterValue?.length) return true;
  const status = row.getValue(columnId) as StatusValue;
  return filterValue.includes(status);
};

export const issuesFilterFn: FilterFn<Creator> = (
  row,
  _columnId,
  filterValue: string[]
) => {
  if (!filterValue?.length) return true;

  const creator = row.original;
  const hasError =
    filterValue.includes("error") && creator.error && creator.error !== "";
  const hasHandOff =
    filterValue.includes("hand_off") && creator.hand_off_to_user === true;
  const notAutopilot =
    filterValue.includes("not_autopilot") && creator.autopilot === false;
  const hasContractChange =
    filterValue.includes("contract_change") &&
    creator.eve_contract_change?.status === "pending";

  return hasError || hasHandOff || notAutopilot || hasContractChange;
};

export const globalFilterFn: FilterFn<Creator> = (
  row,
  _columnId,
  filterValue
) => {
  if (!filterValue) return true;
  const searchTerm = String(filterValue).toLowerCase();

  let username = "";
  const usernameValue = row.getValue("username");
  if (typeof usernameValue === "object" && usernameValue !== null) {
    username = (usernameValue as CreatorAvatar).username?.toLowerCase() || "";
  } else {
    username = String(row.original.username || "").toLowerCase();
  }

  const email = String(row.original.email || "").toLowerCase();

  return username.includes(searchTerm) || email.includes(searchTerm);
};
